import React from "react";
import { TextArea } from "component-library";
import { CrossThickIcon } from "assets";

import "./CastingDirectorNotes.scss";

const MAX_LENGTH = 1000;

export interface ICastingDirectorNotesProps {
  notes?: string;
  changeNotes: (notes: string) => void;
  closeNotes: () => void;
}

export const CastingDirectorNotes: React.FC<
  React.PropsWithChildren<ICastingDirectorNotesProps>
> = (props) => {
  const { notes, changeNotes, closeNotes } = props;

  return (
    <div className="c-casting-director-notes__form">
      <div
        className="c-casting-director-notes__close dark:text-color-neutral-one"
        onClick={closeNotes}
      >
        <CrossThickIcon />
      </div>
      <TextArea
        value={notes}
        valueChanged={changeNotes}
        autoResize
        isLoading={notes === undefined}
        showsCharacterCount
        maxLength={MAX_LENGTH}
      />
    </div>
  );
};
